import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import MenuItem from "@material-ui/core/MenuItem";
import List from "@material-ui/core/List";
import accounting from "accounting";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 100,
  },
  boxDescription: {
    fontStyle: "italic",
  },
  secondaryAction: {
    paddingRight: 133,
  },
});

class Boxes extends Component {
  render() {
    const {
      classes,
      values,
      errors,
      touched,
      handleBlur,
      handleChange,
      isSubmitting,
    } = this.props;

    return (
      <Card>
        <CardContent>
          <List>
            <ListItem
              className={classes.listItem}
              classes={{
                secondaryAction: classes.secondaryAction,
              }}
            >
              <ListItemText
                primary={this.props.box.name}
                secondary={
                  <React.Fragment>
                    <span className={classes.boxDescription}>
                      {this.props.box.description}
                    </span>
                    <br />
                    <span
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="secondary"
                    >
                      {accounting.formatMoney(this.props.box.price)}
                    </span>
                    {" — Shipping Included"}
                  </React.Fragment>
                }
              />
              <ListItemSecondaryAction>
                <TextField
                  name={"box" + this.props.box.id}
                  select
                  label="Quantity"
                  className={classes.textField}
                  disabled={isSubmitting}
                  value={values["box" + this.props.box.id]}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={
                    touched["box" + this.props.box.id] &&
                    errors["box" + this.props.box.id]
                  }
                  error={
                    touched["box" + this.props.box.id] &&
                    !!errors["box" + this.props.box.id]
                  }
                  margin="normal"
                  variant="outlined"
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                </TextField>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </CardContent>
      </Card>
    );
  }
}

Boxes.propTypes = {
  classes: PropTypes.object.isRequired,
  box: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Boxes);
